import React from 'react';
import NavBarAuth from '../components/Navbars/NavBarAuth';
import { Route, Routes } from 'react-router-dom';
import { Container } from 'reactstrap';

//Routes
import routes from '../routes/views.routes';

export default function Auth() {

    return (
        <div className='content-auth'>
            <div className="img-bg"></div>
            <NavBarAuth />
            <Container className='mt-3'>
                <Routes>
                    {
                        routes.filter(route => route.layout == "/auth").map((route, key) => {
                            const Screen = route.component;
                            return (
                                <Route
                                    path={route.path}
                                    element={<Screen />}
                                    key={key}
                                />
                            )
                        })
                    }
                </Routes>
            </Container>
        </div>
    )
}